module.exports = __webpack_public_path__ + ".well-known/assetlinks.json";